// src/theme.js
import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0A4575',
    },
  },
  typography: {
    fontFamily: 'Abel, sans-serif',
    h1: {
      fontFamily: 'Bakbak One, sans-serif',
    },
    h2: {
      fontFamily: 'Bakbak One, sans-serif',
    },
  },
});

export default theme;